<div class="cpb5" fxLayout="row wrap">
   
    <div fxFlex="100" fxFlex.lt-md="100">
      <mat-card class="table-card" appCard>
      
        <mat-card-content>
         
             <app-cat-clas-p-list-table       
             (sort)="onSort($event)"

             [list]="data">
            </app-cat-clas-p-list-table>
            
         
              <app-paginator
             (paginate)="onPaginate($event)"
             [total]="totalCount"
           ></app-paginator> 
        </mat-card-content>
      </mat-card>

    </div>
  </div>
  

  <br>

<div  align="right" *ngIf="current_lang=='fr'|| current_lang=='en'">
  <button [routerLink]="['/portail/Classification']"  mat-raised-button style="background-color:#3E90D0; color: white;">{{"Liste"|translate}}</button>
</div>

<div  style="float: left;" *ngIf="current_lang=='ar'">
  <button [routerLink]="['/portail/Classification']"  mat-raised-button style="background-color:#3E90D0; color: white;">{{"Liste"|translate}}</button>
</div>